import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";

/* ATT Project Vids */
import att_video from "../videos/att/article_monitor.mp4";
import att_video2 from "../videos/att/article_monitor2.mp4";
/* Kaiser Project Vids */
import kaiser_video from "../videos/kaiser/article_monitor.mp4";
import kaiser_video2 from "../videos/kaiser/article_monitor2.mp4";
/* PG Project Vids */
import pg_video from "../videos/pg/article_monitor.mp4";
import pg_video2 from "../videos/pg/article_monitor2.mp4"
/* Morgan Project Vids */
import morgan_video from "../videos/morgan/article_monitor.mp4";
import morgan_video2 from "../videos/morgan/article_monitor2.mp4"
/* GE Project Vids */
import ge_video from "../videos/ge/article_monitor.mp4"; 
import ge_video2 from "../videos/ge/article_monitor2.mp4"
/* Invesco Project Vids */
import invesco_video from "../videos/invesco/article_monitor.mp4";
import invesco_video2 from "../videos/invesco/article_monitor2.mp4"


const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    WEBSITE: "Websites",
    BRAND: "Branding",
    PRINT: "Print",
/*     ADUNIT: "AD-Unit", */
  };

  const projectsData = [
    {
      title: "5G Future of Healthcare",
      projectInfo:
        "In my capacity as the lead front-end developer, I successfully crafted an engaging and interactive article for AT&T that delves into the immense potential of 5G technology in the healthcare sector. The article is strategically designed to showcase the numerous benefits and real-life applications of this cutting-edge technology, while ensuring that healthcare professionals and technology enthusiasts alike enjoy a visually stunning and user-friendly reading experience. The addition of interactive elements such as infographics, animations, and interactive charts further bolster user engagement and interest in the topic.",
      client: "AT&T",
      technologies: "Git, AWS, HTML5, CSS3, JS",
      industry: "Technology",
      role: "Lead Front-End Dev.",
      url: {
        name: "Link to Project Here",
        link: "https://sponsorcontent.cnn.com/interactive/att/5GFutureofHealthcare/",
      },
      thumbImage: "images/projects/att.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/att/mock1.png" />,
        <video src={att_video2} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/att/mock2.png" />,
        <video src={att_video} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/att/mock3.png" />,
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "Mental Healthcare Hub",
      projectInfo:
        "As the leader of the front-end development team, I successfully spearheaded the creation of a top-notch article hub for Kaiser, focusing on Mental Health. Our objective was crystal clear: to deliver an engaging and informative platform that provides users with the best mental health resources and information available. I designed and developed a host of interactive elements, ranging from quizzes to interactive charts and personalized self-assessment tools, all aimed at enhancing user engagement. Our article hub achieved a remarkable reach and received rave reviews from Kaiser for its ability to provide valuable resources and support to users seeking mental health assistance.",
      client: "Kaiser Permanente",
      technologies: "Git, AWS, HTML5, CSS3, JS",
      industry: "Healthcare",
      role: "Lead Front-End Dev.",
      url: {
        name: "Link to Project Here",
        link: "http://sponsorcontent.cnn.com/interactive/kaiserpermanente/english/",
      },
      thumbImage:  "images/projects/kaiser.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/kaiser/mock2.png" />,
        <video src={kaiser_video2} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/kaiser/mock1.png" />,
        <video src={kaiser_video} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/kaiser/mock3.png" />,
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "The Chore Gap Article",
      projectInfo:
        "In my capacity as the primary front-end developer, I took the initiative to create a highly informative and engaging article for P&G, which offers insights on how to achieve a fair and balanced distribution of household tasks. The article was enriched with interactive checklists, quizzes, and personalized chore schedules, which helped to foster user engagement. The feedback received from the article was overwhelmingly positive, and it went on to achieve a substantial reach.",
      client: "P&G",
      technologies: "Git, AWS, HTML5, CSS3, JS",
      industry: "Lifestlye",
      role: "Lead Front-End Dev.",
      url: {
        name: "Link to Project Here",
        link: "https://pg-chaore-gap.s3.amazonaws.com/index.html",
      },
      thumbImage:  "images/projects/pg.png",
      sliderImages: [
        <img className="img-fluid" src="images/projects/pg/mock1.png" />,
        <video src={pg_video2} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid"  src="images/projects/pg/mock2.png" />,
        <video src={pg_video} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" src="images/projects/pg/mock3.png" />,
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "Creating Space Hub",
      projectInfo:
        "In my capacity as the primary front-end developer and UX/UI designer, I played an instrumental role in the creation of an article for Morgan Stanley. The article was focused on exploring the concept of diversity in space travel and featured a comprehensive breakdown of space suits across different generations. The ultimate goal of the project was to develop an engaging and visually appealing article that underscored the importance of diversity in the context of space exploration. To achieve this objective, I was responsible for designing and developing interactive elements such as sliders, animations, and intuitive navigation. These features were specifically tailored to enhance the user experience, making it easy for readers to navigate the article and fully engage with its content. Thanks to the successful implementation of these design elements, the article enjoyed a wide readership and received high praise from Morgan Stanley, who expressed their immense satisfaction with the final result.",
      client: "Morgan Stanley",
      technologies: "Git, AWS, HTML5, CSS3, ReactJS, Figma",
      industry: "Technology",
      role: "Front-End Dev. & UX/UI Designer",
      url: {
        name: "Link to Project Here",
        link: "https://sponsorcontent.cnn.com/interactive/morganstanley/creating-space/",
      },
      thumbImage: "images/projects/morgan.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/morgan/mock1.png" />,
        <video src={morgan_video2} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/morgan/mock2.png" />,
        <video src={morgan_video} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/morgan/mock3.png" />,
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "100 Points of Power Hub",
      projectInfo:
        "As a front-end developer, I played a vital role in creating an article for General Electric that shed light on the significant milestones that have been achieved on the path to providing power to sub-Saharan Africa. The goal was to develop an informative and visually appealing article that would showcase General Electric’s impactful initiatives in the region. Working alongside a team of writers, designers, and photographers, I strived to create an engaging user experience with interactive elements and smooth navigation. The article was widely read and received high praise from General Electric, who expressed immense satisfaction with the final outcome. I’m proud to have been a part of this project that effectively conveyed the importance of power accessibility in sub-Saharan Africa and showcased General Electric’s unwavering commitment to the region.",
      client: "General Electric",
      technologies: "Git, AWS, HTML5, CSS3, JS",
      industry: "Technology",
      role: "Front-End Dev.",
      url: {
        name: "Link to Project Here",
        link: "http://sponsorcontent.cnn.com/interactive/GE/GEPower/100-Points-of-Power/",
      },
      thumbImage: "images/projects/ge.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/ge/mock1.png" />,
        <video src={ge_video2} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/ge/mock2.png" />,
        <video src={ge_video} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/ge/mock3.png" />,
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "Innovation Now Hub",
      projectInfo:
        "I played a pivotal role in the development of an article for Invesco, which was focused on early-stage entrepreneurs. Working alongside a team of writers, designers, and photographers, I ensured that the article was not only engaging but also visually stimulating. My responsibilities included the implementation of various interactive features, optimization of the article’s performance, and the design of a seamless navigation experience to enhance user engagement. The article was widely received and garnered a broad readership. Invesco was exceptionally pleased with the final outcome and expressed their gratitude for the valuable insights we provided to their audience. Overall, the article was a successful demonstration of the journey of early-stage entrepreneurs and left a positive impression on the readership of Invesco.",
      client: "Invesco",
      technologies: "Git, AWS, HTML5, CSS3, JS",
      industry: "Finance",
      role: "Front-End Dev.",
      url: {
        name: "Link to Project Here",
        link: "https://sponsorcontent.cnn.com/interactive/Invesco/InvestingInGreaterPossibilitiesTogether/#/",
      },
      thumbImage: "images/projects/invesco.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/invesco/mock1.png" />,
        <video src={invesco_video2} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/invesco/mock2.png" />,
        <video src={invesco_video} autoPlay muted loop style={{ width: "100%", height: "405px"}}></video>,
        <img className="img-fluid" alt="" src="images/projects/invesco/mock3.png" />,
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "St. Croix Casino Brandbook",
      projectInfo:
        "As the lead creative, I had the amazing opportunity to spearhead the creation of a breathtaking Brand Identity book for the St. Croix Chippewa Indians of Wisconsin’s brand new casino. Our mission was to encapsulate the very essence of their brand and showcase their rich cultural heritage. Working alongside a team of talented designers, photographers, and writers, we brought together traditional elements with modern design aesthetics, resulting in an absolutely stunning book that was visually captivating. The Brand Identity book was a resounding success, effectively communicating the tribe’s values, traditions, and vision for the casino. The St. Croix Chippewa Indians of Wisconsin were absolutely thrilled with the outcome, as the book not only represented their brand identity flawlessly, but also highlighted the incredible cultural significance of their tribe.",
      client: "St. Croix Band Casino",
      technologies: "Photoshop, Illustrator, Indesign",
      industry: "Entertainment",
      role: "Lead Creative",
      thumbImage: "images/projects/croix.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/croix/image1.png" />,
        <img className="img-fluid" alt="" src="images/projects/croix/image2.png" />,
        <img className="img-fluid" alt="" src="images/projects/croix/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/croix/image4.png" />,
        ],
      categories: [filters.BRAND],
    },
   /*  {
      title: "DC Milestone Initiative",
      projectInfo:
        "As a skilled designer and developer, I played a crucial role in the Milestone Initiative collaboration between DC, Milestone Media, and Ally, WarnerMedia. Our primary aim was to create a branded-content magazine that celebrated the initiative while underscoring Milestone Media and Ally's unwavering commitment to promoting diversity and inclusion. The magazine formed part of a comprehensive suite of assets, including five films, sponsorship of CNN content and events, digital sponsorships, social media assets, and customer advertorial content in DC Comics. Moreover, all content associated with The Milestone Summit was incorporated into the partnership. My responsibility involved designing and developing the magazine to effectively convey the message of diversity and inclusion to the intended audience.",
      client: "Ally Bank/DC Comic",
      technologies: "Photoshop, Illustrator, Figma, Celtra",
      industry: "Entertainment",
      role: "Creative Designer & Developer",
      url: {
        name: "Link to Project Here",
        link: "https://preview-sandbox.celtra.com/shareablePreview/e1po21/frame?desktopPreviewFrame=1",
      },
      thumbImage: "images/projects/ally.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
      ],
      categories: [filters.BRAND, filters.ADUNIT],
    },
    {
      title: "Billions Infrographic",
      projectInfo:
        "In my capacity as the Lead Creative, I assumed responsibility for spearheading the development of an interactive and visually captivating infographic for the popular Showtime television series Billions. Specifically, my objective was to create a compelling visual representation that would juxtapose the two main characters. To achieve this end, I worked in concert with a team of designers and data analysts, gathering pertinent information and leveraging our collective expertise to create a product that would engage and captivate viewers. The finished product not only succeeded in sparking significant viewer interaction but also garnered high praise from Showtime, who expressed their complete satisfaction with the outcome. Thanks to our collaboration, the infographic effectively conveyed the complexities of the characters and enhanced viewers’ understanding of the show.",
      client: "Showtime",
      technologies: "Photoshop, Illustrator",
      industry: "Entertainment",
      role: "Lead Creative",
      url: {
        name: "Link to Project Here",
        link: "https://www.example.com",
      },
      thumbImage: "images/projects/showtime.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
      ],
      categories: [filters.PRINT],
    }, */
    {
      title: "Soul Of Brooklyn 8th Annual Fest",
      projectInfo:
        "In my role as Lead Creative, I had the privilege of leading a print design campaign for the 8th Annual Soul of Brooklyn Fest, which was organized by MoCada. The primary objective of this campaign was to create an aesthetically appealing and engaging campaign that would highlight the festival's diverse cultural offerings. To achieve this goal, I worked closely with a talented team of designers, photographers, and copywriters to develop a cohesive visual identity and promotional materials. The campaign was a resounding success, as it effectively captured the essence of the festival and resonated with the target audience. As a result, the festival had a wide reach and received positive feedback from MoCada. It was immensely satisfying to receive such great feedback from the client, as the campaign successfully promoted the 8th Annual Soul of Brooklyn Fest.",
      client: "MoCada",
      technologies: "Photoshop, Illustrator, Indesign",
      industry: "Event",
      role: "Lead Creative",
      thumbImage: "images/projects/mocada.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/mocada/mock1.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/mock2.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/mock3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/mock4.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/mock5.png" />,
      ],
      categories: [filters.PRINT],
    },
/*     {
      title: "Lorena Interactive Ad",
      projectInfo:
        "As the lead developer of the interactive ad unit promoting the Amazon Prime show “Lorena,” I played a pivotal role in its creation. My team and I utilized Celtra, JavaScript, and Photoshop to design and develop the ad units with a clear goal: captivating the audience and engaging them with the show’s intriguing storyline. Through interactive elements and visually stunning graphics, we skillfully generated curiosity and drove viewership. Our ad unit showcased the unique aspects of “Lorena” in a creative yet technically sound way, enticing users to explore the series further.",
      client: "Amazon Prime",
      technologies: "Celtra, JS, Photoshop",
      industry: "Entertainment",
      role: "Lead Developer",
      url: {
        name: "Link to Project Here",
        link: "http://preview-sandbox.celtra.com/preview/62a51934/frame?rp.expandMethod=fullscreen&rp.foldPosition=above&overrides.deviceInfo.deviceType=Desktop",
      },
      thumbImage: "images/projects/prime.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
      ],
      categories: [filters.ADUNIT],
    }, 
    {
      title: "Hotel Mumbai Interactive Ad",
      projectInfo:
        "As the lead ad campaign developer, I successfully spearheaded a highly impactful campaign for Bleecker Street Media’s movie, Hotel Mumbai. My objective was to generate buzz and drive ticket sales, and I did just that. I executed a multi-channel strategy, including social media ads, display ads, and video trailers, targeting movie enthusiasts and fans of intense thrillers. The ad campaign achieved significant reach and engagement, resulting in increased ticket sales and positive feedback from Bleecker Street Media. Their satisfaction with the campaign’s outcome was extremely high.",
      client: "Bleecker Street Media",
      technologies: "Celtra, JS, Photoshop",
      industry: "Entertainment",
      role: "Lead Developer",
      url: {
        name: "Link to Project Here",
        link: "http://preview-sandbox.celtra.com/preview/8d6fb588/frame?rp.expandMethod=fullscreen&rp.foldPosition=above&overrides.clientTimestamp=1552493400&overrides.clientTimeZoneOffsetInMinutes=240&overrides.deviceInfo.deviceType=Desktop",
      },
      thumbImage: "images/projects/bleecker.png",
      sliderImages: [
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
        <img className="img-fluid" alt="" src="images/projects/mocada/image3.png" />,
      ],
      categories: [filters.ADUNIT],
    },*/
  ];

  console.log(projectsData);

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      percentPosition: true,
      layoutMode: "masonry",
       masonry: {
        columnHeight: 0
      }/*,
      cellsByRow: {
        columnWidth: 20,
        rowHeight: 220
      },
      masonryHorizontal: {
        rowHeight: 10
      },
      cellsByColumn: {
        columnWidth: 20,
        rowHeight: 20
      } */
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section id="portfolio" className="section bg-purple">
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative text-center mb-5">
          <h2
            className={
              "sec-header text-24  text-uppercase fw-700 w-100 mb-0 tx-color-2"
            }
          >
              Portfolio
            </h2>
            <p className={
              "text-6 all-cap fw-600 w-100 align-self-center mb-0"
            }>
              Of my best My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu non-display nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div className={ "col-sm-6 col-lg-4 filter-item " + project.categories.join(" ") } key={index} >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <a className="popup-ajax stretched-link" href="" onClick={() => { setSelectedProjectDetails(projectsData[index]); }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="fc-lite fw-500">
                              {project.client}
                            </h5>
                            <h3 className="text-white fw-100">
                              {project.role}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
